__webpack_require__.p = "https://d3hfzdrxu3oxle.cloudfront.net/training-portal/98b8b753ae73396379381d4c1e16e2fc24ccf4e9/_next/";